import type { FormRef } from '@/components/UI/Form/Form'

import type { FormBuilderInputRef, FormBuilderValidationResult } from './types'

export function resetFormStates(refs: (FormRef | FormBuilderInputRef | null)[]): void {
  refs.forEach(ref => {
    if (ref != null) {
      ref.setFormState({ submitting: false, error: null, errors: {} })
    }
  })
}

async function getValidationResultFromRef(
  ref: FormRef | FormBuilderInputRef | null
): Promise<FormBuilderValidationResult> {
  if (ref == null) {
    return { success: true, errors: [] }
  }
  const validationResult = await ref.validate()
  if (validationResult.success === true) {
    return { success: true, errors: [] }
  }
  return { success: false, errors: Object.values(validationResult.errors ?? {}) }
}

export function combineValidationResults(
  results: FormBuilderValidationResult[]
): FormBuilderValidationResult {
  const success = results.every(res => res.success === true)
  const errors = results.flatMap(res => res.errors)
  return { success, errors }
}

export async function getValidationResultFromRefs(
  refs: (FormRef | FormBuilderInputRef | null)[]
): Promise<FormBuilderValidationResult> {
  const results = await Promise.all(refs.map(ref => getValidationResultFromRef(ref)))
  const combinedResult = combineValidationResults(results)
  if (!combinedResult.success) {
    resetFormStates(refs.filter((ref, i) => ref != null && results[i].success))
  }
  return combinedResult
}
